import { formatDisplayDate } from "../../../utils/formatDisplayDate";

export function formatTick(value) {
  if (Number.isInteger(value)) return value.toFixed(1).toString();
  return value.toFixed(2).replace(/\.?0+$/, "");
}

export function formatLengthTick(value, unitValue) {
  if (Number.isInteger(value))
    return unitValue === "English"
      ? value.toFixed(1).toString()
      : value.toFixed(0).toString();
  return value.toFixed(2).replace(/\.?0+$/, "");
}

/** YYYY-MM-DD for API / sort keys — not for user display. */
export function formatDate(date) {
  if (!date) return null;
  if (typeof date === "string" && date.includes("T")) {
    return date.split("T")[0];
  }
  const dateObj = new Date(date);
  return `${dateObj.getFullYear()}-${String(dateObj.getMonth() + 1).padStart(
    2,
    "0"
  )}-${String(dateObj.getDate()).padStart(2, "0")}`;
}

/** User-facing date: MM/DD/YYYY */
export function formatDateTime(dateString) {
  if (!dateString) return "N/A";
  try {
    return formatDisplayDate(dateString);
  } catch {
    return "N/A";
  }
}
